import { ReactNode, useEffect, useRef, useState } from "react";
import { Dialog } from "../Dialog";
import { HrSeparator, Padder, ProfileImage, SimpleButton, SimpleContainer, SimpleInputWithLabel, SimpleLinkButton, SimplePageTemplate, UploadButton } from "./SimpleElements"
import { useUser } from "../../../biz/hooks/entities/useUser";
import { ApiOrganizationUserType, OrganizationHelper, useOrganization } from "../../../biz/hooks/entities/useOrganization";
import { OrganizationProStatus, OrganizationType, TypeOfBusinessType } from "../../../biz/data/redux/organizationReducer";
import { useResizeImage } from "../../../biz/data/io/useResizeImage";
import { ImageUrlBuilder } from "../main/Images";
import { useDialogs } from "./MesssageBoxes";
import { usePricing } from "../../../biz/pricing/usePricing";
import { MapSmall } from "./Maps/MapsElements";
import { IGeoCodeResponse, useGeoCode } from "./Maps/useGeoCode";
import { useGetPro } from "../../../biz/hooks/entities/useGetPro";
import { PortalContainer } from "../main/Portal";
import { Helpers } from "../../../biz/data/Helpers";
import { useFetch } from "../../../biz/hooks/data/useFetcher";
import { RestResponseType } from "../../../biz/data/Types";
import { useRoles } from "../../../biz/hooks/entities/useRoles";
import { useTranslation } from "react-i18next";



export const ProfileUsersEdit = () => {

    const { t } = useTranslation();
    const ui = useProfileUsersEdit();
    useEffect(() => {
        ui.loadInvitedUsers();
    }, [])

    return (
        <div className="profile-edit-users">
            <div className="profile-edit-users-header">
                {t("users")}
            </div>

            {/* List Of users */}
            <div className="profile-edit-users-list">

                {ui.allusers.map(n => (
                    <UserInfoRow key={n?.id} user={n} />
                ))}

            </div>
            {/* <div className="mt-16">
                <SimpleButton onClick={() => ui.setInviteUserVisible(true)} label={"Bjud in användare"} icon="plus" type="secondarybeige30" />
            </div> */}

            {/* Invite User */}
            <Dialog
                visible={ui.inviteUserVisible}
                header="Bjud in användare"
                type="add" className="dialog-invite-user"
                clickOutside={() => ui.setInviteUserVisible(false)}
            >
                <div>
                    Nya användare kommer automatiskt få rättighetsrollen som medlem. Du kan ändra detta efter dem accepterat inbjudan.
                </div>
                <Padder heightPx={32} />
                <div className="dialog-invite-user-form">
                    <SimpleInputWithLabel
                        label={"Ange e-post"}
                        value={ui.newUserEmail}
                        placeholder={"E-post till ny användare"}
                        onChange={e => ui.setNewUserEmail(e?.toLowerCase())}
                    />
                </div>
                <Padder heightPx={32} />
                <div className="buttons">
                    <SimpleButton
                        onClick={() => ui.setInviteUserVisible(false)}
                        label={t("undo")}
                        type="tertiary"
                        shape="bigpill" />

                    <SimpleButton
                        onClick={ui.inviteUserPress}
                        label={t("sendInvitation")}
                        type="primary"
                        shape="bigpill"
                        fullWidth={true} />
                </div>
            </Dialog>
        </div>

    )
}

const UserInfoRow = ({ user }: { user: ApiOrganizationUserType }) => {
    const { t } = useTranslation();
    const me = useUser();
    const [deleteConfirmVisible, setDeleteConfirmVisible] = useState<boolean>(false);
    const r = useRoles();

    return (
        <div className="profile-edit-users-list-item">
            <div className="icon">
                <ProfileImage name={user?.alias} imageid={user?.profileImage} sys_datemodified_utc_epoch={0} />
            </div>
            <div className="texts">
                <div className="texts-role">{r.getRoleName(user?.role)}</div>
                <div className="texts-name">{user?.alias} ({user?.email})</div>
            </div>
            <div className="buttons button-link-row">
                {false && (me?.id !== user?.id) && (OrganizationHelper.isOwnerOrHidden(me.getMyRoleinOrganization())) && (
                    <>
                        <SimpleLinkButton onClick={() => { }} label={"Ändra"} icon="pen" />
                        <SimpleLinkButton onClick={() => setDeleteConfirmVisible(true)} label={t("remove")} icon="times" />
                    </>
                )}
            </div>

        </div>
    )
}


const useProfileUsersEdit = () => {
    const user = useUser();
    const org = useOrganization();
    const organization = org?.currentOrganization;
    const api = useProfileUsersEditApi();

    const dialog = useDialogs();

    // Invite user
    const [inviteUserVisible, setInviteUserVisible] = useState<boolean>(false);
    const [newUserEmail, setNewUserEmail] = useState<string>("");
    useEffect(() => { if (inviteUserVisible) { setNewUserEmail(""); } }, [inviteUserVisible])

    return {
        org: org,
        organization: organization,
        loadInvitedUsers: async () => {
            const data = await api.invitedUsers(organization?.id ?? "");
            // console.log("invitedUsers:", data)
        },
        allusers: org.getMyUsers(organization?.id ?? ""),
        newUserEmail: newUserEmail,
        setNewUserEmail: setNewUserEmail,
        setInviteUserVisible: setInviteUserVisible,
        inviteUserVisible: inviteUserVisible,
        inviteUserPress: async (): Promise<boolean> => {
            const ret = await api.inviteUser(organization?.id ?? "", newUserEmail);
            setInviteUserVisible(false);
            if (ret?.success) {
                dialog.showInfo("Lägg till användare", "Användaren bjöds in");
            } else {
                dialog.showWarning("Lägg till användare", ret.message);
            }
            return ret?.success;
        }
    }
}



const useProfileUsersEditApi = () => {

    const f = useFetch();

    return {
        inviteUser: async (organizationId: string, email: string): Promise<RestResponseType> => {
            // api/organization/{id}/invite
            const url = "/api/organization/" + organizationId + "/invite";
            const ret: RestResponseType = await f.patch(url, { email: email })
            return ret;
        },
        invitedUsers: async (organizationId: string): Promise<RestResponseType> => {
            // api/organization/{id}/invite
            const url = "/api/organization/" + organizationId + "/users/invites";
            const ret: RestResponseType = await f.get(url)

            return ret;
        },
    }
}